<template>
    <modal-component
        :visible="visible"
        id="claim-modal"
        :title="`Claim detail #${claim.id || ''}`"
        size="lg"
        @close="resetModal()"
    >
        <div v-if="claim.id" id="claimPrint" class="p-3">
            <previous-claim
                ref="previousClaims"
                v-if="previousClaims.length"
                :invoice="{ ...invoice, previous_claims: previousClaims }"
            ></previous-claim>

            <div class="widget row w-100 mx-0 p-2 mb-3">
                <div class="col">
                    <div class="row">
                        <div class="col px-1">
                            <p class="mb-0 font-weight-bold text-muted">Payment Control Number</p>
                            <p class="mb-0">{{ claim.payment_control_number }}</p>
                        </div>
                        <div class="col px-1">
                            <p class="mb-0 font-weight-bold text-muted">Check ID Number</p>
                            <p class="mb-0">{{ claim.check_number }}</p>
                        </div>
                        <div class="col px-1">
                            <p class="mb-0 font-weight-bold text-muted">Current Status</p>
                            <p class="mb-0 text-capitalize">{{ claim.internal_status }}</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col px-1">
                            <p class="mb-0 font-weight-bold text-muted">Claim Control Number</p>
                            <p class="mb-0">{{ claim.claim_control_number }}</p>
                        </div>
                        <div class="col px-1">
                            <p class="mb-0 font-weight-bold text-muted">Charge Amount</p>
                            <p class="mb-0">
                                {{ claim.claim_amount ? `$${claim.claim_amount.toFixed(2)}` : "" }}
                            </p>
                        </div>
                        <div class="col px-1">
                            <p class="mb-0 font-weight-bold text-muted">Payment Amount</p>
                            <p class="mb-0">
                                {{
                                    claim.payment_amount
                                        ? `$${claim.payment_amount.toFixed(2)}`
                                        : ""
                                }}
                            </p>
                        </div>
                    </div>
                    <div class="row" v-if="claim.corrected_claim_control_number">
                        <div class="col px-1">
                            <p class="mb-0">
                                <span class=" font-weight-bold text-muted"
                                    >This claim is a correction for </span
                                >{{ claim.corrected_claim_control_number }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row w-100">
                <div class="col">
                    <p class="mb-0 font-weight-bold text-muted">Client Name</p>
                    <p class="mb-0">{{ claim.client_name }}</p>
                </div>
                <div class="col">
                    <p class="mb-0 font-weight-bold text-muted">Funding Source</p>
                    <p class="mb-0">{{ claim.funding_source }}</p>
                </div>
                <div class="col">
                    <p class="mb-0 font-weight-bold text-muted text-nowrap">Insurance ID Number</p>
                    <p class="mb-0">{{ claim.insurance_member_id_number }}</p>
                </div>
                <div class="col">
                    &nbsp;
                </div>
                <div class="col">
                    &nbsp;
                </div>
            </div>

            <div class="row w-100">
                <div class="col">
                    <p class="mb-0 font-weight-bold text-muted">Therapist Name</p>
                    <p class="mb-0">{{ claim.therapist_name }}</p>
                </div>
                <div class="col">
                    <p class="mb-0 font-weight-bold text-muted text-nowrap">Rendering Provider</p>
                    <p class="mb-0">{{ claim.rendering_provider }}</p>
                </div>
                <div class="col">
                    <p class="mb-0 font-weight-bold text-muted">Treatment</p>
                    <p class="mb-0">{{ claim.treatment }}</p>
                </div>
                <div class="col">
                    &nbsp;
                </div>
                <div class="col">
                    &nbsp;
                </div>
            </div>

            <div class="w-100 mt-3" style="background: #212529;">
                <i
                    class="mx-3 fa text-white"
                    :class="statusVisible ? 'fa-minus' : 'fa-plus'"
                    @click="toggleStatus()"
                ></i>
                <span class="font-weight-bold text-white">Status</span>
            </div>
            <div class="widget w-100 p-2" v-show="statusVisible">
                <div class="row">
                    <div class="col-4">
                        <p class="text-muted font-weight-bold small">Claim Activity</p>
                    </div>
                    <div class="col-2">
                        <p class="text-muted font-weight-bold small">Effective Date</p>
                    </div>
                    <div class="col-4">
                        <p class="text-muted font-weight-bold small">Details</p>
                    </div>
                </div>
                <div class="row" v-for="status in claim.statuses">
                    <div class="col-4">
                        {{ status.activity }}
                    </div>
                    <div class="col-2">
                        {{
                            status.updated_at ? moment(status.updated_at).format("MM-DD-YY") : "N/A"
                        }}
                    </div>
                    <div class="col-4">
                        {{ status.details }}
                    </div>
                </div>
            </div>

            <div class="w-100 mt-3" style="background: #212529;">
                <i
                    class="mx-3 fa text-white"
                    :class="chargesVisible ? 'fa-minus' : 'fa-plus'"
                    @click="toggleCharges()"
                ></i>
                <span class="font-weight-bold text-white">Charges</span>
            </div>
            <div class="widget w-100 p-2" v-show="chargesVisible">
                <div class="row">
                    <div class="col-2">
                        <p class="text-muted font-weight-bold small">Service Date</p>
                    </div>
                    <div class="col-3">
                        <p class="text-muted font-weight-bold small">Procedure Code</p>
                    </div>
                    <div class="col-1">
                        <p class="text-muted font-weight-bold small">Units</p>
                    </div>
                    <div class="col-2">
                        <p class="text-muted font-weight-bold small">Service Hours</p>
                    </div>
                    <div class="col-2">
                        <p class="text-muted font-weight-bold small">Diagnostic Code</p>
                    </div>
                    <div class="col-2">
                        <p class="text-muted font-weight-bold small">Charge Amount</p>
                    </div>
                </div>
                <div class="row" v-for="charge in claim.charges">
                    <div class="col-2">
                        {{
                            charge.service_start_at
                                ? moment(charge.service_start_at).format("MM-DD-YY")
                                : "N/A"
                        }}
                    </div>
                    <div class="col-3">
                        <span class="comma-list" v-for="c in charge.cpt_codes">{{ c.code }}</span>
                    </div>
                    <div class="col-1">
                        {{ charge.unit_count }}
                    </div>
                    <div class="col-2">
                        {{ charge.service_hours }}
                    </div>
                    <div class="col-2">
                        <span class="comma-list" v-for="d in charge.diagnoses">{{ d.code }}</span>
                    </div>
                    <div class="col-2">
                        {{ charge.expected_amount ? `$${charge.expected_amount.toFixed(2)}` : "" }}
                    </div>
                </div>
            </div>
            <div class="row form-group my-3">
                <label for="claim-status" class="col-3">Change status:</label>
                <div class="col-2">
                    <select
                        name="claim-status"
                        id="claim-status"
                        class="form-control form-control-sm"
                        v-model="claimInternalStatus"
                    >
                        <option
                            v-for="status in claimInternalStatuses"
                            :value="status"
                            class="text-capitalize"
                        >
                            {{ status.replace(/_/g, " ") }}
                        </option>
                    </select>
                </div>
                <div class="col-2">
                    <button
                        v-if="claimInternalStatus && claimInternalStatus !== claim.internal_status"
                        class="btn btn-sm btn-primary"
                        id="update-claim-status"
                        @click="updateClaimStatus()"
                    >
                        Update status
                    </button>
                </div>
            </div>
            <div class="row form-group my-3">
                <label for="claim-history" class="col-3">Claim History:</label>
                <div class="col-4">
                    <select
                        name="claim-history"
                        id="claim-history"
                        class="form-control form-control-sm"
                        v-model="claimHistorySelected"
                    >
                        <option :value="i" v-for="(c, i) in claims"
                            >Claim {{ c.id }} -
                            {{
                                c.created_at ? moment(c.created_at).format("MM-DD-YY") : ""
                            }}</option
                        >
                        <option :value="null" disabled v-if="!claims.length">
                            No claims
                        </option>
                    </select>
                </div>
            </div>

            <errors :errors="errors"></errors>
        </div>

        <div class="d-flex w-100 justify-content-end">
            <button class="btn btn-sm btn-primary" @click="printElement()">Print</button>
        </div>
    </modal-component>
</template>

<script>
import ModalComponent from "../ui/ModalComponent";
import PreviousClaim from "./FundingSourcesPreviousClaim";
import { helpers } from "../../plugins/helpers";
import { errors } from "../../plugins/errors";

export default {
    name: "Claim",
    props: ["claims"],
    components: { ModalComponent, PreviousClaim },
    mixins: [errors],
    data() {
        return {
            helpers,
            invoice: {}, //set by parent
            visible: false,
            statusVisible: true,
            chargesVisible: true,

            claimInternalStatuses: [
                "pending",
                "acknowledged",
                "hold",
                "rejected",
                "partial_rejection",
                "approved",
                "paid",
                "canceled",
            ],
            claimHistorySelected: 0,
            claimInternalStatus: null,

            previousClaims: [],
        };
    },
    computed: {
        claim() {
            if (this.claims && this.claims.length && !isNaN(this.claimHistorySelected)) {
                return this.claims[this.claimHistorySelected];
            }
            return {
                id: null,
            };
        },
    },
    watch: {
        visible() {
            this.parseClaimStatus();
        },
        claimHistorySelected() {
            this.parseClaimStatus();
        },
        async invoice() {
            if (this.invoice && this.invoice.cob_parent_claim_id) {
                const response = await this.fetchPreviousClaims(this.invoice.cob_parent_claim_id);
                this.previousClaims = _.get(response, "data.previous_claims", []);
            }
            this.parseClaimStatus();
        },
        claims() {
            if (this.claims.length) {
                this.claimHistorySelected = 0;
            }
        },
    },

    methods: {
        async fetchPreviousClaims(parentClaimId) {
            return await axios.get(
                `/api/organizations/${
                    this.$root.organization.id
                }/secondary_invoices/${parentClaimId}/preview`
            );
        },

        parseClaimStatus() {
            const claim = this.claims[this.claimHistorySelected];
            if (claim) {
                this.claimInternalStatus = claim.internal_status;
            }
        },

        toggleStatus() {
            this.statusVisible = !this.statusVisible;
        },

        toggleCharges() {
            this.chargesVisible = !this.chargesVisible;
        },

        getInvoicePatient() {
            axios
                .get(`/api/patients/${this.invoice.patient.id}`)
                .then(r => {
                    this.patient = r.data.data;
                })
                .catch(e => {
                    console.error(e);
                });
        },

        updateClaimStatus() {
            this.setErrors();
            helpers.toggleSpinner("update-claim-status");
            axios
                .patch(
                    `/api/organizations/${this.$root.organization.id}/invoices/${
                        this.invoice.id
                    }/claims/${this.claim.id}`,
                    { internal_status: this.claimInternalStatus }
                )
                .then(response => {
                    this.$emit("update-invoice", this.invoice.id);
                    helpers.toggleSpinner("update-claim-status");
                })
                .catch(error => {
                    this.setErrors(_.get(error, "response.data.errors", {}));
                    helpers.toggleSpinner("update-claim-status");
                });
        },

        resetModal() {
            this.claimHistorySelected = 0;
            this.claimInternalStatus = null;
            this.visible = false;
            this.invoice = {};
            this.previousClaims = [];
        },

        printElement() {
            let elem = document.getElementById("claimPrint");
            let domClone = elem.cloneNode(true);

            let printSection = document.getElementById("printSection");
            if (!printSection) {
                printSection = document.createElement("div");
                printSection.id = "printSection";
                document.body.appendChild(printSection);
            }
            printSection.innerHTML = "";

            printSection.appendChild(domClone);

            window.print();
        },
    },
};
</script>

<style scoped>
.invoice-logo {
    height: 1in;
}
.invoice-paid {
    font-size: 1.25rem;
}
</style>
